<template>
	<div class="id">
		<van-nav-bar :title="name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="waterfall-container">
			<div class="waterfall-column" v-for="(column, index) in columns" :key="index">
				<div class="waterfall-item" v-for="item in column" :key="item.id"
					@click="$router.push({path:'/concubineDetails',query: {id:item.id}});">
					<img :src="item.image" />
					<div class="item-content">{{ item.name }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mockData: [],
				columns: [], // 2列瀑布流
				id: this.$route.query.id,
				name: this.$route.query.name,
			};
		},
		created() {
			this.fetchData()
		},
		computed: {

		},
		methods: {
			back() {
				return window.history.back();
			},
			fetchData() {
				this.$http({
					method: "get",
					url: "getBeautyList",
					data: {
						city_id: this.id
					}
				}).then((res) => {
					if (res.code == 1) {
						console.log(res.data)
						this.mockData = res.data;
						const evens = this.mockData.filter((item, index) => index % 2 === 0);
						const odds = this.mockData.filter((item, index) => index % 2 !== 0);
						this.columns = [evens, odds];
					} else {
						this.$toast(res.msg);
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.id {
		min-height: 100vh;
		background-color: #f2f2f5;
	}

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
		margin-bottom: 20px;
	}

	.waterfall-container {
		display: flex;
		padding: 20px;
		overflow-y: scroll;
		height: calc(100vh - 140px);
	}

	.waterfall-column {
		flex: 1;
		margin: 0 5px;
	}

	.waterfall-item {
		margin-bottom: 10px;
		padding: 20px;
		background: #fff;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

	}

	.waterfall-item img {
		width: 100%;
		display: block;
		border-radius: 10px;
		object-fit: contain;
	}

	.item-content {
		padding-top: 20px;
		font-size: 24px;
	}
</style>